exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vfc-time-picker-container[data-v-49a44f90] {\n  min-width: 250px;\n}\n.vfc-time-picker-container .vfc-modal-time-line > span > span[data-v-49a44f90]:not(:nth-child(2)):not(.vfc-active):hover {\n  cursor: pointer;\n}\n.vfc-time-picker-container .titles[data-v-49a44f90] {\n  display: flex;\n  padding: 10px 0;\n}\n.vfc-time-picker-container .titles > div[data-v-49a44f90] {\n  flex: 1;\n  text-align: center;\n  color: #66b3cc;\n  word-break: break-all;\n  font-size: 25px;\n}\n.vfc-time-picker-container .vfc-time-picker[data-v-49a44f90] {\n  padding-bottom: 20px;\n}", ""]);

// exports
